import CurveCreatorController from './curve-creator.controller';

const template = require<string>('./curve-creator.html');

const curveCreatorComponent:ng.IComponentOptions = {
  bindings: {
    selectedDischargeDataItems: '<',
    dischargeModels: '<',
    newModel: '<',
    startingDate: '<',
    onNewModelChange: '&'
  },
  controller: CurveCreatorController,
  require: {
    parent: '^?imomoOperationalInputCurve'
  },
  template
};

export default curveCreatorComponent;



/** WEBPACK FOOTER **
 ** ./app/operational/input/curve-creator.component.ts
 **/